import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './views/Home';
import Application from './views/Application';
import './App.css';
import { initializeSessionData } from './utils/session';

function App() {
  const [isAllowed, setIsAllowed] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const initializeSession = async () => {
      const success = await initializeSessionData();
      setIsAllowed(success);
      setIsChecking(false);
    };

    initializeSession();
  }, []);

  if (isChecking) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Güvenlik kontrolü yapılıyor...</p>
      </Box>
    );
  }

  if (!isAllowed) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', textAlign: 'center' }}>
        <h2>Erişim Engellendi</h2>
        <p>IP adresiniz alınamadığı için siteye girişinize izin verilememektedir.</p>
      </Box>
    );
  }

  return (
    <Router>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Navbar />
        <Box component="main" sx={{ flexGrow: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/application" element={<Application />} />
            <Route path="/application/altyapi-sorunu" element={<Application />} />
            <Route path="/application/yavas-internet-sorunu" element={<Application />} />
          </Routes>
        </Box>
        <Footer />
      </Box>
    </Router>
  );
}

export default App;
